<app-table
  #table
  [config]="tableConfig"
  [(selectedElements)]="selectedElements"
></app-table>
